module.exports = __webpack_public_path__ + "static/media/sfo_logo.54c3ebc4.jpeg";